import React from 'react';
import type { WorkoutActionChipCategory } from '@/types';
import type { TranslationKeys } from '@/core/i18n/translations';

interface Props {
  t: (key: keyof TranslationKeys) => string;
  categories: WorkoutActionChipCategory[];
  onSelect: (text: string) => void;
  isVisible: boolean;
}

export const WorkoutActionChips: React.FC<Props> = ({ t, categories, onSelect, isVisible }) => {
  if (!isVisible) return null;

  return (
    <div className="mt-3 space-y-2 motion-safe:animate-in motion-safe:fade-in motion-safe:duration-200">
      <p className="text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">
        {t('workoutActionChipsTitle')}
      </p>
      <div className="flex flex-wrap gap-1.5">
        {categories.map((category) =>
          category.items.map((item) => (
            <button
              key={`${category.name}-${item.label}`}
              type="button"
              onClick={() => onSelect(item.text)}
              className="flex items-center justify-center gap-1.5 min-h-10 px-3 py-1.5 bg-white dark:bg-slate-800/90 border border-slate-200 dark:border-slate-600
                         rounded-full text-sm text-slate-700 dark:text-slate-200 hover:border-blue-400 dark:hover:border-blue-500
                         hover:bg-blue-50 dark:hover:bg-blue-950/50 transition-all duration-200 shadow-sm hover:shadow touch-manipulation"
            >
              <span aria-hidden>{item.icon}</span>
              <span>{item.label}</span>
            </button>
          ))
        )}
      </div>
    </div>
  );
};
